import React, { useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { apiSetupCreditSubscription } from 'services/BillingService'
import CreditCardCheckoutForm from './form'
import { Skeleton } from 'components/ui'
import { useSelector } from 'react-redux'

const CreditCardForm = ({ selectedPackage, termsOfUseContent }) => {
    const [clientSecret, setClientSecret] = useState('')
    const [subTotalAmount, setSubTotalAmount] = useState(0)
    const [totalAmount, setTotalAmount] = useState(0)
    const [startingDate, setStartingDate] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [paymentMethods, setPaymentMethods] = useState([]) // State for saved payment methods
    const [stripePromise, setStripePromise] = useState(null) // State for Stripe instance

    const { changePackageTo } = useSelector(
        (state) => state.checkout.selectPlan
    )

    useEffect(() => {
        const initCheckout = async () => {
            const response = await apiSetupCreditSubscription({
                package_id: selectedPackage.id,
            })
            if (response.data) {
                const data = response.data.data
                setClientSecret(data.clientSecret)
                setSubTotalAmount(data.subTotalAmount)
                setTotalAmount(data.totalAmount)
                setStartingDate(data.startingDate)
                setPaymentMethods(data.paymentMethods) // Store payment methods from response

                // Dynamically load the Stripe instance with the public key from the API
                const stripeKey = data.stripePublicKey // Assuming API returns `stripePublicKey`
                setStripePromise(loadStripe(stripeKey))

                setIsLoading(false)
            }
        }
        selectedPackage && initCheckout()
    }, [selectedPackage, changePackageTo])

    return isLoading ? (
        <div className="flex flex-col gap-4">
            <Skeleton height={150} />
            <Skeleton height={40} />
        </div>
    ) : (
        selectedPackage && clientSecret && stripePromise && (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
                <CreditCardCheckoutForm
                    clientSecret={clientSecret}
                    subTotalAmount={subTotalAmount}
                    totalAmount={totalAmount}
                    startingDate={startingDate}
                    selectedPackage={selectedPackage}
                    paymentMethods={paymentMethods}
                    termsOfUseContent={termsOfUseContent}
                />
            </Elements>
        )
    )
}

export default CreditCardForm
